<template>
  <skeleton-wrapper>
    <template #body>
      <div :class="$style.skeleton_wrapper">
        <div :class="[$style.skeleton_box, $style.first]">
          <div :class="$style.skeleton_row_main">
            <div :class="$style.skeleton_mb30">
              <skeleton-item
                :style="{width: `124px`, height: '12px'}"
                :type="'bar'"
              />
            </div>
            <skeleton-item
              :style="{width: `496px`, height: '12px'}"
              :type="'bar'"
            />
            <skeleton-item
              :style="{width: `496px`, height: '12px'}"
              :type="'bar'"
            />
            <skeleton-item
              :style="{width: `344px`, height: '12px'}"
              :type="'bar'"
            />
          </div>
          <div :class="$style.skeleton_row_main">
            <div :class="[$style.skeleton_line, $style.skeleton_mb22]">
              <div
                style="margin-right: 105px"
              >
                <div
                  :class="[$style.skeleton_line, $style.skeleton_mb8]"
                >
                  <div
                    :class="[$style.skeleton_mr8]"
                  >
                    <skeleton-item
                      :style="{width: `52px`, height: '12px'}"
                      :type="'bar'"
                    />
                  </div>
                  <skeleton-item
                    :style="{width: `100px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="$style.skeleton_line">
                  <div
                    :class="[$style.skeleton_mr8]"
                  >
                    <skeleton-item
                      :style="{width: `52px`, height: '12px'}"
                      :type="'bar'"
                    />
                  </div>
                  <skeleton-item
                    :style="{width: `100px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
              <div>
                <div :class="[$style.skeleton_mb8]">
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div>
                  <skeleton-item
                    :style="{width: `100px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
            </div>
            <div :class="[$style.skeleton_line]">
              <div :class="[$style.skeleton_mr24]">
                <div :class="[$style.skeleton_mb16]">
                  <skeleton-item
                    :style="{width: `100px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div>
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
              <div :class="[$style.skeleton_mr16]">
                <div :class="[$style.skeleton_mb16]">
                  <skeleton-item
                    :style="{width: `100px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div>
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
              <div :class="[$style.skeleton_bl, $style.skeleton_pl24 ]">
                <div :class="[$style.skeleton_mb16]">
                  <skeleton-item
                    :style="{width: `100px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div>
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="$style.skeleton_flex_row">
          <div :class="[$style.skeleton_box, $style.direction_column]">
            <div :class="[$style.skeleton_mb26]">
              <skeleton-item
                :style="{width: `124px`, height: '12px'}"
                :type="'bar'"
              />
            </div>
            <div :class="[$style.skeleton_mb26, $style.skeleton_flex, $style.skeleton_flex_row_center, $style.skeleton_flex_column_center]">
              <div :class="[$style.skeleton_circle]">
                <skeleton-item
                  :style="{width: `241px`, height: '241px', 'border-width': '50px'}"
                  :type="'donut'"
                />
              </div>
              <div :class="[$style.skeleton_list]">
                <div :class="[$style.skeleton_mb12, $style.skeleton_flex]">
                  <skeleton-item
                    :style="{width: `24px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="[$style.skeleton_mb12, $style.skeleton_flex]">
                  <skeleton-item
                    :style="{width: `24px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="[$style.skeleton_mb12, $style.skeleton_flex]">
                  <skeleton-item
                    :style="{width: `24px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="[$style.skeleton_flex]">
                  <skeleton-item
                    :style="{width: `24px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
            </div>
            <div :class="[ $style.skeleton_flex, $style.skeleton_flex_row_center, $style.skeleton_flex_column_center]">
              <div :class="[$style.skeleton_flex, $style.skeleton_flex_row_center, $style.skeleton_flex_column_center, $style.skeleton_line_padding]">
                <div :class="[$style.skeleton_flex, $style.skeleton_mr16]">
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `24px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="[$style.skeleton_flex, $style.skeleton_bl, $style.skeleton_mr16, $style.skeleton_pl24 ]">
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <div>
                    <skeleton-item
                      :style="{width: `24px`, height: '12px'}"
                      :type="'bar'"
                    />
                  </div>
                </div>
                <div :class="[$style.skeleton_flex, $style.skeleton_bl, $style.skeleton_pl24 ]">
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                  <div>
                    <skeleton-item
                      :style="{width: `24px`, height: '12px'}"
                      :type="'bar'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="[$style.skeleton_box, $style.direction_column]">
            <div :class="[$style.skeleton_mb26]">
              <skeleton-item
                :style="{width: `124px`, height: '12px'}"
                :type="'bar'"
              />
            </div>
            <div :class="[$style.skeleton_chart, $style.skeleton_flex, $style.skeleton_flex_row_center, $style.skeleton_flex_column_center]">
              <div :class="[$style.skeleton_mb26, $style.skeleton_flex, $style.skeleton_flex_column_center]">
                <skeleton-item
                  :style="{width: `24px`, height: '12px'}"
                  :type="'bar'"
                />
                <skeleton-item
                  :style="{width: `349px`, height: '1px'}"
                  :type="'bar'"
                />
              </div>
              <div :class="[$style.skeleton_mb26, $style.skeleton_flex, $style.skeleton_flex_column_center]">
                <skeleton-item
                  :style="{width: `24px`, height: '12px'}"
                  :type="'bar'"
                />
                <skeleton-item
                  :style="{width: `349px`, height: '1px'}"
                  :type="'bar'"
                />
              </div>
              <div :class="[$style.skeleton_mb26, $style.skeleton_flex, $style.skeleton_flex_column_center]">
                <skeleton-item
                  :style="{width: `24px`, height: '12px'}"
                  :type="'bar'"
                />
                <skeleton-item
                  :style="{width: `349px`, height: '1px'}"
                  :type="'bar'"
                />
              </div>
              <div :class="[$style.skeleton_mb26, $style.skeleton_flex, $style.skeleton_flex_column_center]">
                <skeleton-item
                  :style="{width: `24px`, height: '12px'}"
                  :type="'bar'"
                />
                <skeleton-item
                  :style="{width: `349px`, height: '1px'}"
                  :type="'bar'"
                />
              </div>
              <div :class="[$style.skeleton_mb26, $style.skeleton_flex, $style.skeleton_flex_column_center]">
                <skeleton-item
                  :style="{width: `24px`, height: '12px'}"
                  :type="'bar'"
                />
                <skeleton-item
                  :style="{width: `349px`, height: '1px'}"
                  :type="'bar'"
                />
              </div>
              <div :class="[$style.skeleton_flex, $style.skeleton_flex_column_center]">
                <skeleton-item
                  :style="{width: `24px`, height: '12px'}"
                  :type="'bar'"
                />
                <skeleton-item
                  :style="{width: `349px`, height: '1px'}"
                  :type="'bar'"
                />
              </div>
              <div :class="[$style.skeleton_chart_columns]">
                <div :class="[$style.skeleton_chart_columns_item]">
                  <skeleton-item
                    :style="{width: `57px`, height: '77px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="[$style.skeleton_chart_columns_item]">
                  <skeleton-item
                    :style="{width: `57px`, height: '191px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
                <div :class="[$style.skeleton_chart_columns_item]">
                  <skeleton-item
                    :style="{width: `57px`, height: '130px'}"
                    :type="'bar'"
                  />
                  <skeleton-item
                    :style="{width: `52px`, height: '12px'}"
                    :type="'bar'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </skeleton-wrapper>
</template>

<script>

import SkeletonItem from '$$vueCmp/skeletons/skeletonItem.vue';
import SkeletonWrapper from '$$vueCmp/skeletons/skeletonWrapper.vue';

export default {
  name: 'SkeletonMain',
  components: { SkeletonWrapper, SkeletonItem },

};
</script>

<style module lang="less" src="./../less/skeleton.less"></style>
